import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const FileVideoIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" rx="4" fill="#00A0B1" />
    <path d="M12 8L6 11.4641L6 4.5359L12 8Z" fill="white" />
  </Icon>
)
